import {Component, ElementRef} from '@angular/core';
import {UtilityService} from './utility.service';
import {TranslateService} from './translation/translate.service';
import {ApiConfiguration} from './api-configuration';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'upload-request';
  constructor(private elementRef: ElementRef,
              private utilityService: UtilityService,
              private translateService: TranslateService,
              protected config: ApiConfiguration) {
    utilityService.setNodeId(this.elementRef.nativeElement.getAttribute('nodeId'));
    utilityService.setStrictNode(this.elementRef.nativeElement.getAttribute('strictnode') === 'true');
    if (this.elementRef.nativeElement.getAttribute('targetNotExists') === 'false') {
      utilityService.setTargerNodeExists(false);
    }
    this.translateService.use(this.elementRef.nativeElement.getAttribute('language'));
    this.config.rootUrl = environment.api_path;
  }
}
